import styled from "styled-components";
import { TitleStyled } from "../../../../../base/text/title/views/desktop/styled.js";
export const FeaturesWrapper = styled.div.withConfig({
    displayName: "styled__FeaturesWrapper",
    componentId: "sc-4788c742-0"
})`
	& .variant-primary ${TitleStyled} {
		color: ${({ theme  })=>theme.colors.grays.darker};
	}

	& .variant-primary {
		background: transparent;
	}
`;

//# sourceMappingURL=styled.js.map